import { useAuthMutation } from 'features/common/apiUtils/queryHelper';
import { useQueryClient } from 'react-query';
import { AxiosInstance } from 'axios';
import { GroupDataApp } from 'features/user-group/user-group-list/components/groupListTableHelpers';
import { groupsApiConfig } from 'features/user-groups/api';

interface OrgGroup {
  groupId: string;
  name?: string;
  description?: string;
  roles?: GroupDataApp[];
}

const {
  update_delete_group: { url, scope },
  get_groups: { queryKey },
} = groupsApiConfig;

export const useUpdateOrgGroup = () => {
  const queryClient = useQueryClient();

  return useAuthMutation(
    (axiosInstance: AxiosInstance) =>
      async ({ groupId, name, description }: OrgGroup) => {
        return await axiosInstance.patch(url(groupId), {
          name,
          description,
        });
      },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(queryKey);
      },
    },
    scope,
  );
};

export const useUpdateOrgGroupRole = () => {
  const queryClient = useQueryClient();

  return useAuthMutation(
    (axiosInstance: AxiosInstance) =>
      async ({ groupId, roles }: OrgGroup) => {
        return await axiosInstance.patch(url(groupId), {
          roles,
        });
      },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(queryKey);
      },
    },
    scope,
  );
};
